/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */
/*
 * Exporter la totalités des models du sites
 * @export reducers/index.ts
 *
 */
export * from '@tunnel-store/reducers/login';
export * from '@tunnel-store/reducers/logout';
export * from '@tunnel-store/reducers/supervision/display/extraction-video/home';
export * from '@tunnel-store/reducers/supervision/lapiTmp';
export * from '@tunnel-store/reducers/supervision/display/extraction-video/update';
export * from '@tunnel-store/reducers/supervision/display/home';
export * from '@tunnel-store/reducers/supervision/display/updated';
export * from '@tunnel-store/reducers/supervision/camera/created';
export * from '@tunnel-store/reducers/supervision/camera/settings';
export * from '@tunnel-store/reducers/supervision/camera/statistics';
export * from '@tunnel-store/reducers/supervision/camera/settings/settings';
export * from '@tunnel-store/reducers/supervision/camera/settings/getCameraInhibitions';
export * from '@tunnel-store/reducers/supervision/camera/home';
export * from '@tunnel-store/reducers/supervision/camera/remove';
export * from '@tunnel-store/reducers/supervision/camera/update';
export * from '@tunnel-store/reducers/supervision/extractor/home';
export * from '@tunnel-store/reducers/supervision/extractor/lists';
export * from '@tunnel-store/reducers/supervision/impacts/home';
export * from '@tunnel-store/reducers/supervision/impacts/incidentinhibate';
export * from '@tunnel-store/reducers/supervision/inhibitions/home';
export * from '@tunnel-store/reducers/supervision/inhibitions/camera';
export * from '@tunnel-store/reducers/supervision/impacts/incidentrules';
export * from '@tunnel-store/reducers/supervision/impacts/modal/loaded';
export * from '@tunnel-store/reducers/supervision/impacts/modal/updated';
export * from '@tunnel-store/reducers/supervision/systems/home';
export * from '@tunnel-store/reducers/supervision/systems/config';
export * from '@tunnel-store/reducers/supervision/systems/sectionzones';
export * from '@tunnel-store/reducers/supervision/systems/setsectionsettings';
export * from '@tunnel-store/reducers/supervision/systems/trafficdirection';
export * from '@tunnel-store/reducers/supervision/dashboard/home';
export * from '@tunnel-store/reducers/supervision/simulator/home';
export * from '@tunnel-store/reducers/supervision/incident/home';
export * from '@tunnel-store/reducers/actions/camerasbysection';
export * from '@tunnel-store/reducers/actions/notification';
export * from '@tunnel-store/reducers/actions/isqualified';
export * from '@tunnel-store/reducers/actions/progressbar';
export * from '@tunnel-store/reducers/actions/changepassword';
export * from '@tunnel-store/reducers/actions/extractpdfincident';
export * from '@tunnel-store/reducers/actions/getallzone';
export * from '@tunnel-store/reducers/actions/getcamerabeforeandafterbylocation';
export * from '@tunnel-store/reducers/actions/getmaskbyzone';
export * from '@tunnel-store/reducers/actions/gettypeofincidents';
export * from '@tunnel-store/reducers/actions/extractpdfincident';
export * from '@tunnel-store/reducers/actions/inhibitions/created';
export * from '@tunnel-store/reducers/actions/inhibitions/remove';
export * from '@tunnel-store/reducers/actions/replay';
export * from '@tunnel-store/reducers/actions/replaydownload';
export * from '@tunnel-store/reducers/actions/camera/updatezone';
export * from '@tunnel-store/reducers/actions/camera/reset';
export * from '@tunnel-store/reducers/actions/camera/export-csv';
export * from '@tunnel-store/reducers/actions/authorization';
export * from '@tunnel-store/reducers/actions/right';
export * from '@tunnel-store/reducers/actions/emailforgetpassword';
export * from '@tunnel-store/reducers/actions/newpassword';
export * from '@tunnel-store/reducers/actions/checknewincidents';
export * from '@tunnel-store/reducers/actions/checkincidentsisnotqualify';
export * from '@tunnel-store/reducers/actions/checkcamerazonemask';
export * from '@tunnel-store/reducers/actions/camera/switchsegmented';
export * from '@tunnel-store/reducers/actions/section/switchsegmented';
export * from '@tunnel-store/reducers/actions/section/reset';
export * from '@tunnel-store/reducers/explorer/home';
export * from '@tunnel-store/reducers/explorer/extract';
export * from '@tunnel-store/reducers/explorer/search';
export * from '@tunnel-store/reducers/tools/citilogIncident';
export * from '@tunnel-store/reducers/tools/citilogIncident/extract';
export * from '@tunnel-store/reducers/tunnelwatch/home';
export * from '@tunnel-store/reducers/tunnelwatch/onecamera';
export * from '@tunnel-store/reducers/tunnelwatch/camerabyid';
export * from '@tunnel-store/reducers/administration/versionning';
export * from '@tunnel-store/reducers/administration/users/home';
export * from '@tunnel-store/reducers/administration/users/created';
export * from '@tunnel-store/reducers/administration/users/removed';
export * from '@tunnel-store/reducers/administration/users/updated';
export * from '@tunnel-store/reducers/lapi-tmd';



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/index.ts